import type { ReactNode } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../lib/queryClient';
import { I18nProvider } from '../lib/i18n';
import { ToastProvider } from '../components';
import { AuthProvider } from '../features/auth/AuthProvider';
import { BrandingProvider } from '../features/org/BrandingProvider';

/**
 * Provider order matters: queries wrap auth, because the auth provider clears
 * the cache on sign-out; branding sits inside auth because it reads the current
 * org.
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <I18nProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrandingProvider>
            <ToastProvider>{children}</ToastProvider>
          </BrandingProvider>
        </AuthProvider>
      </QueryClientProvider>
    </I18nProvider>
  );
}
